var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8VenderEstoque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M36 36c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3S34.343 36 36 36M21 36c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3S19.343 36 21 36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M36 38c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1S35.448 38 36 38M21 38c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1S20.448 38 21 38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#009688",
    d: "M20.008,32c-1.102,0-1.999-0.896-2-1.999L18,19.998l-4,0.004l0.008,10.003c0.003,3.306,2.694,5.995,6,5.995H39v-4H20.008z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#009688",
    d: "M36.968,24H20.173H20v-0.027c-0.355-0.063-0.658-0.305-0.775-0.656l-4.86-14.582C13.818,7.1,12.293,6,10.569,6H7.011v4h3.559l5.544,16.632c0.068,0.203,0.166,0.391,0.289,0.556C16.772,27.689,17.364,28,18.011,28h20.896c0.787,0,1.501-0.462,1.823-1.179L42,24H36.968z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00695C",
    d: "M9,8c0,1.105-0.895,2-2,2S5,9.105,5,8s0.895-2,2-2S9,6.895,9,8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9800",
    d: "M40,24H20c-1.105,0-2-0.895-2-2V8c0-1.105,0.895-2,2-2h20c1.105,0,2,0.895,2,2v14C42,23.105,41.105,24,40,24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A5100",
    d: "M34,10c0,0.553-0.447,1-1,1h-6c-0.553,0-1-0.447-1-1l0,0c0-0.553,0.447-1,1-1h6C33.553,9,34,9.447,34,10L34,10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8VenderEstoque);
export default __webpack_public_path__ + "static/media/icons8-vender-estoque.6101a94b6fd8660177b0e712c6af36d7.svg";
export { ForwardRef as ReactComponent };